// timeUtils.js
export function getTimeStatus(startDate, endDate) {
    const currentDate = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (currentDate < start) {
        return "Upcoming";
    } else if (currentDate >= start && currentDate <= end) {
        return "Running";
    } else {
        return "Past";
    }
}

export function toSafeISOString(val) {
    if (!val) return null;
    if (typeof val.isValid === "function") {
        return val.isValid() ? val.toISOString() : null;
    }
    const d = val?.$d instanceof Date ? val.$d : (val instanceof Date ? val : new Date(val));
    return d instanceof Date && !isNaN(d.getTime()) ? d.toISOString() : null;
}

